import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectProfilesSearchText = createSelector(
  [(store: RootState) => store.profilesList.searchText],
  (filter) => filter
);